import { InjectionToken } from "@angular/core";
import { Config } from "@core/models/config";


export const BASE_URL = new InjectionToken<string>('BASE_URL');
export const SERVER_SIDE = new InjectionToken<boolean>('SERVER_SIDE');
export const CONFIG = new InjectionToken<Config>('CONFIG');